<template>
  <div class="h-full m-auto py-2 px-4">
    <h2 class="py-4 text-2xl">Drop Ship</h2>
    <div class="py-4 flex flex-row" style="height:800px">
      <div class="w-1/4 bg-white border flex flex-col">
          <div class="p-2 text-left font-bold">Dropship Suppliers</div>
          <div class="pl-2 pb-1 text-left underline border-t-2">Agromillora Florida</div><div class="pl-2 pb-2 text-left">(Florida Citrus) (-AG)</div>
          <div class="pl-2 pb-1 text-left underline border-t-2">Arizona Olives & Ornamentals</div><div class="pl-2 pb-2 text-left">(Arizona) (-AZ)</div>
          <div class="pl-2 pb-1 text-left underline border-t-2">Brazos</div><div class="pl-2 pb-2 text-left">(Texas) (-TX)</div>
          <div class="pl-2 pb-1 text-left underline border-t-2">Four Winds</div><div class="pl-2 pb-2 text-left">(California) (-FW)</div>
          <div class="pl-2 pb-1 text-left underline border-t-2">Georgia Grown Citrus&nbsp;LLC</div><div class="pl-2 pb-2 text-left">(Georgia) (-GA)</div>
          <div class="pl-2 pb-1 text-left underline border-t-2">Green Circle Growers</div><div class="pl-2 pb-2 text-left">(Nation Wide Gift Items)<br/>(-GC)</div>
          <div class="pl-2 pb-1 text-left underline border-t-2">Marlborough Greenhouses Inc.</div><div class="pl-2 pb-2 text-left">(New Hampshire) (-ML)</div>
          <div class="pl-2 pb-1 text-left underline border-t-2">Silver Falls</div><div class="pl-2 pb-2 text-left">(Oregon) (-SF)</div>
          <div class="pl-2 pb-1 text-left underline border-t-2">Sureseed</div><div class="pl-2 pb-2 text-left">(Oregon) (-Turboturf)</div>
          <div class="pl-2 pb-1 text-left underline border-t-2">Western Star Nurseries</div><div class="pl-2 pb-2 text-left border-b-2">(California Non-Citrus)(-WS)</div>         
      </div>
      <div class='w-full ml-4'>
        <ag-grid-vue
          style="height: 100%; width: 100%;"
          class="ag-theme-balham"
          :columnDefs="columnDefs"
          :rowData="rowData"
          :paginationAutoPageSize="false"
          :paginationPageSize="paginationPageSize"
          :pagination="true"
          id="inventory-available"
          :gridOptions="gridOptions"
          @grid-ready="onGridReady"
          :context="context"
          :frameworkComponents="frameworkComponents"
          :defaultColDef="defaultColDef"
          :enableCellTextSelection="true"
          :ensureDomOrder="true"
        >
        </ag-grid-vue>
      </div>
    </div>  
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import { ApiFactory } from "@/api/ApiFactory.js";
import ShopifyFGTLink from "./components/ShopifyFGTLink";
import ShopifyBBLink from "./components/ShopifyBBLink";

const InventoriesApi = ApiFactory.get("inventories");

export default {
  name: "DropShip",
  components: {
    AgGridVue,
    ShopifyFGTLink, // eslint-disable-line
    ShopifyBBLink, // eslint-disable-line
  },
  props: {},
  data() {
    return {
      columnDefs: null,
      rowData: null,
      paginationPageSize: 24,
      frameworkComponents: null,
      gridApi: null,
      columnApi: null,
      gridOptions: null,
      context: null,
      defaultColDef: null,
      overlayLoadingTemplate: true
    };
  },
  computed: {},
  async created() {
    const response = await ApiFactory.get("feature-flags").isFeatureFlagEnabled("phase3d_care_app");

    if (response.status == 200) {
      if (response.data.body.enabled) {
        await this.$router.push({ name: "Dashboard" });
      }
    }
  },
  beforeMount() {
    this.gridOptions = {};

    this.context = { componentParent: this };

    this.defaultColDef = {
      sortable: true,
      filter: true,
      suppressMovable: true,
    };

    this.columnDefs = [
      {
        headerName: "SKU",
        field: "LocalSKU",
        minWidth: 150,
      },
      {
        headerName: "Name",
        field: "ItemName",
        minWidth: 250
      },
      {
        headerName: "Supplier",
        field: "Supplier",
        flex: 1,
        minWidth: 250
      },
      {
        headerName: "FGT",
        field: "Shopify.FGT",
        cellRendererFramework: "ShopifyFGTLink",
        maxWidth: 100,
        type: 'rightAligned'
      },
      {
        headerName: "BB",
        field: "Shopify.BB",
        cellRendererFramework: "ShopifyBBLink",
        maxWidth: 100,
        type: 'rightAligned'
      }
    ];

    InventoriesApi.dropship({
      drop_ship: 1
    }).then(response => {
      this.rowData = response.data.body.map(row => {
        return {
          LocalSKU: row.LocalSKU,
          ParentID: row.ParentID,
          ItemName: row.ItemName,
          QOH: row.QOH,
          Committed: row.Committed,
          Total: row.Total,
          Backordered: row.Backordered,
          OnOrder: row.OnOrder,
          Growing: row.Growing,
          Active_FGT: row.Active_FGT,
          Active_BB: row.Active_BB,
          Shopify: row.Shopify,
          Supplier: row.Supplier
        };
      });
    });
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
  },
  methods: {
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onGridReady() {}
  },
  filters: {}
};
</script>
<style lang="scss">
@import "../../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
@import "../../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
</style>
